import { render, staticRenderFns } from "./RecordPoster.vue?vue&type=template&id=15c6ec6e&"
import script from "./RecordPoster.vue?vue&type=script&lang=js&"
export * from "./RecordPoster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports